/*
 * Cart drawer invoice note
 * -------------------------
 * Handles the "Ich benötige eine Rechnung" checkbox in the cart drawer.
 * - Toggles the invoice-data textarea open/closed.
 * - Keeps the cart note in sync via the AJAX cart API so the entered
 *   invoice data survives the drawer re-rendering (#CartDrawer-Body is
 *   replaced on every cart update).
 * - The textarea also carries name="note" inside #CartDrawer-FormSummary,
 *   so on "Zur Kasse" the value is submitted and stored as the order note.
 *
 * Listeners are delegated on `document` (attached once) because the drawer
 * markup is re-inserted via innerHTML and inline scripts would not re-run.
 */
(function () {
  if (window.__cartInvoiceNoteInit) return;
  window.__cartInvoiceNoteInit = true;

  var routeRoot =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var debounceTimer;

  function updateCartNote(note) {
    fetch(routeRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    }).catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var checkbox = e.target.closest && e.target.closest('#CartDrawer-InvoiceToggle');
    if (!checkbox) return;

    var fields = document.getElementById('CartDrawer-InvoiceFields');
    var textarea = document.getElementById('CartDrawer-InvoiceNote');

    if (checkbox.checked) {
      if (fields) fields.hidden = false;
      if (textarea) {
        textarea.disabled = false;
        textarea.focus();
      }
    } else {
      if (fields) fields.hidden = true;
      if (textarea) {
        textarea.value = '';
        textarea.disabled = true;
      }
      updateCartNote('');
    }
  });

  document.addEventListener('input', function (e) {
    var textarea = e.target.closest && e.target.closest('#CartDrawer-InvoiceNote');
    if (!textarea) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      updateCartNote(textarea.value);
    }, 400);
  });
})();
